import React from 'react';

const ADSyncedUser: React.FC<React.PropsWithChildren> = () => (
  <svg viewBox="0 0 24 24">
    <path
      d="M9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM9.05 17H4.77C5.76 16.5 7.47 16 9 16C9.11 16 9.23 16.01 9.34 16.01C9.68 15.28 10.27 14.68 10.98 14.2C10.25 14.07 9.56 14 9 14C6.66 14 2 15.17 2 17.5V19H9V17.5C9 17.33 9.02 17.16 9.05 17Z"
      fill-opacity="0.87"
      stroke="transparent"
    />
    <path
      d="M16 10C13.79 10 12 10.9944 12 12.2222C12 13.45 13.79 14.4444 16 14.4444C18.21 14.4444 20 13.45 20 12.2222C20 10.9944 18.21 10 16 10ZM12 13.3333V15C12 16.2278 13.79 17.2222 16 17.2222C18.21 17.2222 20 16.2278 20 15V13.3333C20 14.5611 18.21 15.5556 16 15.5556C13.79 15.5556 12 14.5611 12 13.3333ZM12 16.1111V17.7778C12 19.0056 13.79 20 16 20C18.21 20 20 19.0056 20 17.7778V16.1111C20 17.3389 18.21 18.3333 16 18.3333C13.79 18.3333 12 17.3389 12 16.1111Z"
      fill-opacity="0.87"
      stroke="transparent"
    />
  </svg>
);

export default ADSyncedUser;
